import React from "react";
import "./index.css"; // Importa el archivo de estilos CSS específico para el footer
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import YouTubeIcon from "@mui/icons-material/YouTube";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import PrivacyTipIcon from "@mui/icons-material/PrivacyTip";
import LocalPoliceIcon from "@mui/icons-material/LocalPolice";
import CookieIcon from "@mui/icons-material/Cookie";
import { useWindowSize } from "@utils/resize";

function Footer() {
  const { width } = useWindowSize();

  return (
    <footer className="footer">
      {width < 1300 && (
        <>
          <div className="logos-derecha">
            <img
              src="/Logotipo_Castilla-La_Mancha.png"
              className="encabezado-image grande"
              alt="Logo Castilla-La Mancha"
            />
            <img
              src="/logo_ministerio.png"
              className="encabezado-image mediano"
              alt="Logo Ministerio"
              style={{ width: "200px" }}
            />
          </div>
          <div className="logos-derecha">
            <img
              src="/logo_recursos_humanos.png"
              className="encabezado-image grande-plus"
              alt="Logo Recursos Humanos"
              style={{ width: "200px" }}
            />
          </div>
        </>
      )}
      <img
        width="200"
        height="100"
        src="https://www.sice.com/wp-content/uploads/2023/08/SICE_logo-updated_ok.svg"
        alt="SICE logo"
      />
      <hr className="divisor" />
      <div className="about">
        <a className="link" href="https://www.sice.com/contacto/">
          <MailOutlineIcon sx={{ color: "white", width: "15px" }} />
          <span className="link-descripcion">Contacto</span>
        </a>
        <a className="link" href="https://www.sice.com/politica-de-privacidad/">
          <PrivacyTipIcon sx={{ color: "white", width: "15px" }} />
          <span className="link-descripcion">Política Privacidad</span>
        </a>
        <a className="link" href="https://www.sice.com/aviso-legal/">
          <LocalPoliceIcon sx={{ color: "white", width: "15px" }} />
          <span className="link-descripcion">Aviso Legal</span>
        </a>
        <a className="link" href="https://www.sice.com/politica-de-cookies/">
          <CookieIcon sx={{ color: "white", width: "15px" }} />
          <span className="link-descripcion">Política Cookies</span>
        </a>
      </div>
      <div className="redes-sociales">
        <a href="https://www.linkedin.com/company/sice">
          <LinkedInIcon
            sx={{ width: "5px", color: "white" }}
            className="icon-circle"
          />
        </a>
        <a href="https://www.youtube.com/@sicetecnologiaysistemas">
          <YouTubeIcon
            sx={{ width: "5px", color: "white" }}
            className="icon-circle"
          />
        </a>
      </div>
      <span className="copyright">
        COPYRIGHT © SICE - TODOS LOS DERECHOS RESERVADOS
      </span>
    </footer>
  );
}

export default Footer;
